import type * as React from 'react';
import { get } from '@Domain/Api';
import aiModelFamiliesFetched, {
	type AiModelFamiliesFetchedAction,
	type AiModelFamiliesFetchedPayload,
} from '@Application/Ai/AiModelFamilies/Actions/aiModelFamiliesFetched';
import aiModelFamiliesFetchFailed, {
	type AiModelFamiliesFetchFailedAction,
} from '@Application/Ai/AiModelFamilies/Actions/aiModelFamiliesFetchFailed';
import type FetchAiModelFamilies from '@Application/Ai/AiModelFamilies/Queries/FetchAiModelFamilies';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = AiModelFamiliesFetchedAction | AiModelFamiliesFetchFailedAction;

export default (_query: FetchAiModelFamilies) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<AiModelFamiliesFetchedPayload>(
				`${parameters.api.host}/api/enums/ai-model-families`,
			);

			const action = aiModelFamiliesFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiModelFamiliesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
